<template>
  <div class="cr-page-detail">
    <div v-if="pageLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
    <div v-if="pageError" class="mc-error">{{ pageError }}</div>
    <div v-if="pageLoaded" class="cr-text">
      <div class="cr-container" v-html="page.text">
      </div>
    </div>
  </div>
</template>

<script>

import product from "@/mixin/product.vue";
import {mapActions, mapGetters} from "vuex";
import ProductItem from "@/views/components/ProductItem.vue";
import axios from "axios";
import scrollToError from "@/mixin/scrollToError.vue";


export default {
  data: () => ({

  }),

  created() {
    this.fetchPage(this.$route.params.id);
  },
  computed: {
    ...mapGetters('page', [
      'page',
      'pageLoading',
      'pageError',
      'pageLoaded',
    ]),
    shareSupported() {
      return navigator.share
    }
  },
  methods: {
    ...mapActions('page', [
      'fetchPage'
    ]),
      }
}
</script>
